import { defineMessages } from 'react-intl';

export const placesAutoCompleteMsgs = defineMessages({
    searchPlaces: {
        id: 'placesAutoComplete.searchPlaces',
        defaultMessage: 'Search Places ...',
    },
});
